import { Users } from "../Users/index.js";
/*
 *   Copyright (c) 2022 Busy Human LLC
 *   All rights reserved.
 *   This file, its contents, concepts, methods, behavior, and operation  (collectively the "Software") are protected by trade secret, patent,  and copyright laws. The use of the Software is governed by a license  agreement. Disclosure of the Software to third parties, in any form,  in whole or in part, is expressly prohibited except as authorized by the license agreement.
 */
export var Auth;
(function (Auth) {
    let UserTypeClaim;
    (function (UserTypeClaim) {
        UserTypeClaim["CommunicationCenterUser"] = "communicationCenterUser";
        UserTypeClaim["OCC"] = "occ";
        UserTypeClaim["Pilot"] = "pilot";
        UserTypeClaim["CrewUser"] = "crewUser";
        UserTypeClaim["CommsSpec"] = "comms-specialist";
        UserTypeClaim["CommsSuper"] = "comms-supervisor";
    })(UserTypeClaim = Auth.UserTypeClaim || (Auth.UserTypeClaim = {}));
})(Auth || (Auth = {}));
//# sourceMappingURL=index.js.map